
// 环境
export const API_BASE_URL = '/api';

export const BASE_URL = 'https://orks.com.cn';